import { getWindowSafe } from '@change-corgi/core/window';

const window = getWindowSafe();

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
export const KEEPALIVE_SUPPORTED = !!window && !!window.Request && 'keepalive' in new window.Request('');

export function isKeepaliveSupported(): boolean {
	return KEEPALIVE_SUPPORTED;
}

export function isSendBeaconSupported(): boolean {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	return !!window && !!window.navigator?.sendBeacon;
}
